<app-modal-filler-atom
  (click)="onClose()"
  [index]="10"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow mdMax:bottom-0 mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="60"
>
  <app-modal-filler-atom
    class="hidden md:block"
    [withBackdrop]="false"
    (onClick)="onClose()"
    [index]="10"
  ></app-modal-filler-atom>
  <div
    class="p-5 bg-white md:min-w-448 md:p-7 rounded-t-3xl md:rounded-3xl md:max-w-lg md:w-2/5"
    [style.z-index]="60"
  >
    @if (activeStep === registrationStep.STEP_PHONE) {
      <app-phone-number-step
        [phone]="phone"
        (setPhone)="setPhone($event)"
        (goToNextStep)="onGoToOtpStep()"
        (goToAuthenticationStep)="onGoToAuthenticationStep()"
        (goToAccountNotFoundStep)="onGoToAccountNotFoundStep()"
        (goToKioskAccountNotFoundStep)="onGoToKioskAccountNotFoundStep()"
        (onClose)="onClose($event)"
        [accentColor]="accentColor"
      ></app-phone-number-step>
    }
    @if (activeStep === registrationStep.STEP_OTP) {
      <app-otp-step
        [phone]="phone"
        (onClose)="onClose($event)"
        (goToPreviousStep)="onGoToPhoneStep()"
        (goToNextStep)="onGoToAuthenticationStep()"
      ></app-otp-step>
    }
    @if (activeStep === registrationStep.STEP_AUTHENTICATION) {
      <app-authentication-step
        (onClose)="onClose($event)"
        (onComplete)="onComplete($event)"
        (onKioskConfirm)="onGoToConfirmationStep()"
      ></app-authentication-step>
    }
    @if (activeStep === registrationStep.STEP_KIOSK_CONFIRMATION) {
      <app-kiosk-confirmation-step
        (onComplete)="onComplete($event)"
        [accentColor]="accentColor"
      ></app-kiosk-confirmation-step>
    }
    @if (activeStep === registrationStep.STEP_KIOSK_REGISTER) {
      <app-kiosk-register-step
        [phone]="phone"
        (onClose)="onClose($event)"
        (setPhone)="setPhone($event)"
        (goToKioskRegisterConfirmationStep)="onGoToKioskRegisterConfirmationStep()"
        [accentColor]="accentColor"
      ></app-kiosk-register-step>
    }
    @if (activeStep === registrationStep.STEP_KIOSK_REGISTER_CONFIRMATION) {
      <app-kiosk-register-confirmation-step
        (onComplete)="onComplete()"
        [accentColor]="accentColor"
      ></app-kiosk-register-confirmation-step>
    }
    @if (activeStep === registrationStep.STEP_KIOSK_ACCOUNT_NOT_FOUND) {
      <app-kiosk-account-not-found-step
        [phone]="phone"
        (goToPhoneStep)="onGoToPhoneStep()"
        (goToRegisterStep)="onGoToRegisterStep()"
        (onComplete)="onComplete($event)"
        [accentColor]="accentColor"
      ></app-kiosk-account-not-found-step>
    }
    @if (activeStep === registrationStep.STEP_ACCOUNT_NOT_FOUND) {
      <app-account-not-found-step
        [phone]="phone"
        (onClose)="onClose($event)"
        (goToPhoneStep)="onGoToPhoneStep()"
      ></app-account-not-found-step>
    }
  </div>
</div>
